/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      loadFilters();
      toggleActiveFilters();

      $( '.event-filters-form' ).on( 'submit', function( e ) {
        e.preventDefault();
        filterEvents();
        loadFilters();
        toggleActiveFilters();
      } );

      $( document ).on( 'click', '.remove-filter', function() {
        const filterId = $( this ).attr( 'data-remove' );
        $( this ).closest( 'li' ).remove();

        if ( filterId == 'event-search' ) {
          $( 'input[type="search"]' ).val( '' ).trigger( 'change' );
        } else if ( filterId == 'date-filter' ) {
          $( 'input[name="event_date_filter"]' ).prop( 'checked', false ).trigger( 'change' );
          $( 'input[name="event_start_date"], input[name="event_end_date"]' ).val( '' ).trigger( 'change' );
          $( '#custom-date-range' ).addClass( 'hidden' );
        } else {
          $( 'input#' + filterId ).prop( 'checked', false ).trigger( 'change' );
        }
        $( '.event-filters-form' ).trigger( 'submit' );
      } );

      $( document ).on( 'click', '.clear-all-filters', function() {
        $( '.event-filters__active-filters li' ).remove();
        $( 'input[type="search"], input[type="date"]' ).val( '' ).trigger( 'change' );
        $( 'input[type="radio"], input[type="checkbox"]' ).prop( 'checked', false ).trigger( 'change' );
        $( '#custom-date-range' ).addClass( 'hidden' );
        $( '.event-filters-form' ).trigger( 'submit' );
      } );

      $( document ).on( 'click', '.events__pagination button', function() {
        filterEvents( $( this ).attr( 'data-value' ) );
      } );

      $( 'input[name="event_date_filter"]' ).on( 'change', function() {
        if ( $( this ).val() === 'custom-date-range' ) {
          $( '#custom-date-range' ).removeClass( 'hidden' );
        } else {
          $( '#custom-date-range' ).addClass( 'hidden' );
        }
      } );

      $( '[data-dropdown]' ).on( 'click', function() {
        $( this ).toggleClass( 'is-open' );
        $( $( this ).attr( 'data-dropdown' ) ).toggleClass( 'is-open' );
      } );

      function loadFilters() {
        $( '.event-filters-form' ).find( 'input' ).each( function( key, val ) {
          const filter = $( val ).attr( 'data-filter' );
          let value = $( val ).find( '~ label' ).text();
          let filterId = '';

          if ( $( val ).attr( 'type' ) == 'search' ) {
            value = $( val ).val();
            id = $( val ).attr( 'id' );
            filterId = 'Search Filter';
            $( '[data-id="' + filterId + '"]' ).remove();

            if ( $( '[data-id="' + filterId + '"]' ).length == 0 ) {
              if ( $( val ).val().length > 0 ) {
                $( '.event-filters__active-filters ul' ).append( '<li data-id="' + filterId + '"> <span class="filter-label"><span class="sr-only">' + filter + ':</span> ' + value + '</span> <button type="button" class="remove-filter" data-remove="' + id + '" aria-label="Remove filter: ' + filter + ' - ' + value + '"> <svg class="icon icon-Close" aria-hidden="true"><use xlink:href="#icon-Close"></use></svg> </button> </li>' );
              }
            }
          } else {
            value = $( val ).find( '~ label' ).text();
            id = $( val ).attr( 'id' );
            filterId = filter + ' - ' + value;

            if ( $( val ).is( ':checked' ) && $( val ).val() == 'custom-date-range' ) {
              if ( $( '[data-id="custom-date-range"]' ).length == 0 ) {
                $( '[data-id="date-filter"]' ).remove();
                let startDate = $( 'input[name="event_start_date"]' ).val();
                let endDate = $( 'input[name="event_end_date"]' ).val();

                if ( startDate !== '' ) {
                  const [y, m, d] = startDate.split( '-' );
                  const startDateFormatted = `${m}/${d}/${y}`;
                  startDate = startDateFormatted;
                }

                if ( endDate !== '' ) {
                  const [y, m, d] = endDate.split( '-' );
                  const endDateFormatted = `${m}/${d}/${y}`;
                  endDate = endDateFormatted;
                }

                if ( startDate !== '' && endDate !== '' ) {
                  value = startDate + ' - ' + endDate;
                } else if ( startDate !== '' ) {
                  value = startDate;
                } else if ( endDate !== '' ) {
                  value = endDate;
                }

                $( '.event-filters__active-filters ul' ).append( '<li data-id="date-filter"> <span class="filter-label"><span class="sr-only">' + filter + ':</span> ' + value + '</span> <button type="button" class="remove-filter" data-remove="date-filter" aria-label="Remove filter: Custom Date Range"> <svg class="icon icon-Close" aria-hidden="true"><use xlink:href="#icon-Close"></use></svg> </button> </li>' );
              }
            } else if ( $( val ).is( ':checked' ) && $( val ).attr( 'name' ) == 'event_date_filter' ) {
              if ( $( '[data-id="date-filter"]' ).length == 0 ) {
                $( '[data-id="date-filter"]' ).remove();
                $( '.event-filters__active-filters ul' ).append( '<li data-id="date-filter"> <span class="filter-label"><span class="sr-only">' + filter + ':</span> ' + value + '</span> <button type="button" class="remove-filter" data-remove="date-filter" aria-label="Remove filter: ' + filter + ' - ' + value + '"> <svg class="icon icon-Close" aria-hidden="true"><use xlink:href="#icon-Close"></use></svg> </button> </li>' );
              }
            } else if ( $( val ).is( ':checked' ) ) {
              if ( $( '[data-id="' + filterId + '"]' ).length == 0 ) {
                if ( $( val ).is( ':checked' ) ) {
                  $( '.event-filters__active-filters ul' ).append( '<li data-id="' + filterId + '"> <span class="filter-label"><span class="sr-only">' + filter + ':</span> ' + value + '</span> <button type="button" class="remove-filter" data-remove="' + id + '" aria-label="Remove filter: ' + filter + ' - ' + value + '"> <svg class="icon icon-Close"><use xlink:href="#icon-Close"></use></svg> </button> </li>' );
                } else {
                  $( '[data-id="' + filterId + '"]' ).remove();
                }
              }
            }
          }
        } );
      }

      function toggleActiveFilters() {
        if ( $( '.event-filters__active-filters ul li' ).length > 0 ) {
          $( '.event-filters__active-filters' ).removeClass( 'hidden' );
        } else {
          $( '.event-filters__active-filters' ).addClass( 'hidden' );
        }
      }

      function filterEvents( page = 1 ) {
        $( '#event-results-wrapper' ).addClass( 'is-loading' );
        const form = $( '.event-filters-form' );
        const queryString = form.serialize();
        const url = form.attr( 'action' ) + '?' + queryString;

        // Update the URL
        history.pushState( {filters: queryString}, '', url );

        const searchText = $( 'input[name="search_text"]' ).val();
        const eventDate = $( 'input[name="event_date_filter"]:checked' ).val();

        let eventStartDate = null;
        let eventEndDate = null;

        if ( eventDate === 'custom-date-range' ) {
          eventStartDate = $( 'input[name="event_start_date"]' ).val();
          eventEndDate = $( 'input[name="event_end_date"]' ).val();
        }

        const eventType = $( 'input[name="event_type_filter[]"]:checked' ).map( function() {
          return this.value;
        } ).get();

        const eventVenue = $( 'input[name="event_venue_filter[]"]:checked' ).map( function() {
          return this.value;
        } ).get();

        const eventPartner = $( 'input[name="event_partner_filter[]"]:checked' ).map( function() {
          return this.value;
        } ).get();

        const data = {
          'page': page,
          'search_text': searchText,
          'event_date': eventDate,
          'event_start_date': eventStartDate,
          'event_end_date': eventEndDate,
          'event_type': eventType,
          'event_venue': eventVenue,
          'event_partner': eventPartner,
        };

        $.ajax( {
          type: 'GET',
          url: siteInfo.wpApiSettings.ll + 'cpt/filter', // note that cpt/filter is the path set in our new route in routes.php
          data: data,
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', siteInfo.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            console.log( data );
            $( '#event-results-wrapper' ).html( data.events ).removeClass( 'is-loading' );
            $( '#results-heading' ).trigger( 'focus' );
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
          },
        } );
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'events', COMPONENT );
} )( app );
